import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataDestService } from '../../component-data-dest.service';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export interface CreateInstructorInvitationPayload {
  event_guids: string[];
  invitee_user_ids: number[];
  response_deadline: string;
}

export const create_instructor_invitation = (
  service: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: CreateInstructorInvitationPayload
): Observable<any> => {
  return service.http.post<{ guid: string; id: number; response_deadline: string; status: string }>(
    `${environment.apiUrl}/events/instructor-invitations`,
    data
  ).pipe(
    catchError(error => {
      console.error('[create_instructor_invitation] Error:', error);
      throw error;
    })
  );
};
